import React from 'react';
import {render} from 'react-dom';
import './index.css';
import App from './App';
import theme from './theme';
import { ThemeProvider } from '@material-ui/core';

render(
  <ThemeProvider theme={theme}>
      <App />
  </ThemeProvider>, 
  document.getElementById('app'));
